import styled from 'styled-components';

const FVHeaderStyled = {
    Container: styled.div`
        display: flex;
        gap: 16px;
        align-items: center;
        height: 77px;
        justify-content: center;

        @media screen and (max-width: 1280px) {
            padding-left: 22px;
        }
    `,

    Content: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        max-width: 1280px;
        height: 100%;

        @media screen and (max-width: 580px) {
            flex-direction: column;
            align-items: start;
            gap: 8px;


            button {
                align-self: end;
            }
        }
    `,
};

export default FVHeaderStyled;
